// @flow
import React, { Component } from 'react';

import type { CreditCardSummary } from '@rover/react-lib/types';

import RoverLoading from '@rover/react-lib/components/utils/RoverLoading';

import SelectPaymentMethodForm from './components/SelectPaymentMethodForm';

import type { AppProps } from './';

export type Props = AppProps & {
  creditCards: Array<CreditCardSummary>,
  isLoading: boolean,
  setServiceType: string => void,
};

export type State = {
  ccFormIsDisabled: boolean,
};

export default class ConversationsCheckoutPage extends Component<Props, State> {
  static defaultProps = {
    recieveSetDisabledReactCCFormUIFunc: () => {},
  };

  constructor(props: Props) {
    super(props);

    props.recieveSetDisabledReactCCFormUIFunc(this.disableCCForm);
  }

  state = {
    ccFormIsDisabled: false,
  };

  componentDidMount() {
    const { setServiceType, serviceType } = this.props;
    setServiceType(serviceType);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.creditCards.length !== this.props.creditCards.length) {
      this.props.onAddOrRemoveCard();
    }
  }

  disableCCForm = () => {
    this.setState(() => ({ ccFormIsDisabled: true }));
  };

  render() {
    const { isLoading } = this.props;
    return (
      <RoverLoading isLoading={isLoading}>
        <SelectPaymentMethodForm disabled={this.state.ccFormIsDisabled} />
      </RoverLoading>
    );
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/ConversationsCheckoutPage/ConversationsCheckoutPage.jsx